// 9fbef606107a605d69c0edbcd8029e5d 
import { withRouter } from 'next/router'; // eslint-disable-line
import AddedToBagCommonContainer from './AddedToBagCommonContainer';

export default withRouter(AddedToBagCommonContainer);
